"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertaModal = void 0;
var globalMu_1 = __importDefault(require("../../../globalMu"));
var Botao_1 = require("../../Botao/Botao");
var Cores_1 = require("../../Cores/Cores");
var Icone_1 = require("../../Icone/Icone");
var Corpo_1 = require("../../Tipografia/Corpo/Corpo");
var react_1 = __importStar(require("react"));
var Card_1 = require("../../Card/Card");
var Titulo_1 = require("../../Tipografia/Titulo/Titulo");
var Modal_1 = require("../../Modal/Modal");
var estilosAlertaModal = require("./AlertaModal.module.scss");
var AlertaModal = function (_a) {
    var _b;
    var alerta = _a.alerta, isOpen = _a.isOpen, onClose = _a.onClose, repositorio = _a.repositorio;
    var _c = (0, react_1.useState)(false), mostrarBaixado = _c[0], setMostrarBaixado = _c[1];
    var baixarRelatorioErro = function (alert) {
        var _a;
        setMostrarBaixado(true);
        var now = new Date();
        var hours = String(now.getHours()).padStart(2, "0");
        var minutes = String(now.getMinutes()).padStart(2, "0");
        var seconds = String(now.getSeconds()).padStart(2, "0");
        var formatted = now.toLocaleDateString("pt-BR");
        var hour = "".concat(hours, ":").concat(minutes, ":").concat(seconds);
        var tituloRelatorio = [
            "=".repeat(50),
            "RELAT\u00D3RIO ".concat((_a = alert.titulo) === null || _a === void 0 ? void 0 : _a.toUpperCase(), "        gerado em ").concat(formatted, " \u00E0s ").concat(hour),
            "=".repeat(50)
        ].join("\n");
        var detalhesTecnicos = "Detalhes T\u00E9cnicos:\n    ".concat(alert.descricao);
        var infoTelemetria = "Informa\u00E7\u00F5es de Telemetria:\n   ".concat(globalMu_1.default.formatarTelemetria(alert.telemetria));
        var erroRelatorio = [
            tituloRelatorio,
            detalhesTecnicos,
            "",
            infoTelemetria,
            "--------------------------------------------",
            ""
        ].join("\n");
        var blob = new Blob([erroRelatorio], { type: "text/plain" });
        var url = URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = url;
        a.download = "erro-".concat(hour, ".txt");
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };
    var renderRodapeModal = function (alert) { return (react_1.default.createElement("div", { className: estilosAlertaModal["alert-modal-footer"] },
        mostrarBaixado && (react_1.default.createElement(Corpo_1.Corpo, { tipo: "body3", negrito: 700, cor: Cores_1.Cores.GradacaoPrimaria.AzulMedioMU600 }, "Baixado!")),
        react_1.default.createElement(Botao_1.Botao, { estilo: "primaryDark", tamanho: "medium", onClick: function () { return baixarRelatorioErro(alert); } },
            react_1.default.createElement(Icone_1.Icone, { nome: "download", altura: "1rem", largura: "1rem", cor: Cores_1.Cores.GradacaoNeutros.BrancoMU50 }),
            "Baixar"),
        react_1.default.createElement(Botao_1.Botao, { id: "fecharBotao", tamanho: "medium", estilo: "outlined", onClick: onClose },
            react_1.default.createElement(Icone_1.Icone, { altura: "1rem", largura: "1rem", nome: "close", cor: Cores_1.Cores.GradacaoNeutros.CinzaFillMU600 }),
            react_1.default.createElement(Corpo_1.Corpo, { tipo: "button1", cor: Cores_1.Cores.GradacaoNeutros.CinzaFillMU600 }, "Fechar")))); };
    var renderCorpoModal = function (alertMessage, repositorio) { return (react_1.default.createElement("div", { className: estilosAlertaModal["alert-modal-corpo"] },
        react_1.default.createElement(Corpo_1.Corpo, { cor: Cores_1.Cores.GradacaoNeutros.CinzaFillMU600, tipo: "body3" }, alertMessage.tipo === "error"
            ? globalMu_1.default.filtrarStackTrace(alertMessage.descricao, repositorio)
            : alertMessage.descricao))); };
    return (react_1.default.createElement("div", { className: isOpen
            ? estilosAlertaModal["alert-modal"]
            : estilosAlertaModal["alert-modal-hidden"], id: "alertaModal" },
        react_1.default.createElement(Modal_1.Modal, { isOpen: isOpen, onClose: onClose, style: {
                display: "flex",
                borderRadius: "8px",
                justifyContent: "center",
                alignItems: "center",
                width: "100vw",
            } },
            react_1.default.createElement(Card_1.Card, { style: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                    width: "100%",
                    height: "auto",
                    padding: "24px",
                }, rodape: renderRodapeModal(alerta) },
                react_1.default.createElement("div", { style: { display: "flex", gap: "10px" }, className: "tituloCard" },
                    react_1.default.createElement("div", { style: {
                            backgroundColor: "rgba(210, 28, 28, 0.2)",
                            borderRadius: "50%",
                            alignContent: "center",
                            padding: "8px",
                        }, className: estilosAlertaModal["icon"] }, alerta.icone ? (alerta.icone) : (react_1.default.createElement(Icone_1.Icone, { style: {
                            width: "1.25rem",
                            height: "1.25rem",
                        }, cor: Cores_1.Cores.MensagensDoSistema.VermelhoMU, nome: alerta.tipo }))),
                    react_1.default.createElement("div", { style: { marginBottom: "12px" }, className: "titulos" },
                        react_1.default.createElement(Titulo_1.Titulo, { negrito: true, tipo: "cabecalho3" }, alerta.titulo),
                        react_1.default.createElement(Corpo_1.Corpo, { cor: Cores_1.Cores.GradacaoNeutros.CinzaFillMU600, tipo: "caption" }, (_b = alerta.descricao) === null || _b === void 0 ? void 0 :
                            _b.split(".")[0],
                            "."))),
                react_1.default.createElement("div", { style: { marginBottom: "12px" } },
                    react_1.default.createElement(Titulo_1.Titulo, { tipo: "cabecalho3", negrito: true }, "Detalhes T\u00E9cnicos:")),
                renderCorpoModal(alerta, repositorio)))));
};
exports.AlertaModal = AlertaModal;
